import Logger from "../../../../utils/Logger";
const MSCORE_HEADER = "ILS,PID,DATE,DA_SID,TEST,VOLUME_B,IP_SRC:PORT_SRC,IP_DST:PORT_DST,TCP_CONG,TIME_ELAPSED_MS,THROUGHPUT_KBPS,#SEG,#ACK,#RETRANS,#RETRANS_SACK,#RETRANS_RTO,GEOIP_AS,GEOIP_COUNTRY,GEOIP_CITY,USER_AGENT,HOST,TCP_OPTIONS,INIT_RWIN_B,MAX_RWIN_B,NB_RTT,RTT_MIN_MS,RTT_AVG_MS,RTT_MAX_MS,JITTER_MIN_MS,JITTER_AVG_MS,JITTER_MAX_MS,NB_SYN,NB_SYNACK,DA_UID,DA_GROUP_ID,DA_CELL,RCA_RWIN_PERCENT,RCA_CONGESTION_PERCENT,RCA_STALL_PERCENT,RCA_RETRANS_PERCENT,RCA_CWND_PERCENT,TARGET_RTT_MS,ACHIEVABLE_THROUGHPUT_KBPS,PERCENTILE10_THROUGHPUT_KBPS,PERCENTILE50_THROUGHPUT_KBPS,PERCENTILE90_THROUGHPUT_KBPS,PERCENTILE10_RTT_MS,PERCENTILE50_RTT_MS,PERCENTILE90_RTT_MS,PERCENTILE10_RWIN_B,PERCENTILE50_RWIN_B,PERCENTILE90_RWIN_B,PERCENTILE10_BIF_B,PERCENTILE50_BIF_B,PERCENTILE90_BIF_B,PERCENTILE10_INTERACK_MS,PERCENTILE50_INTERACK_MS,PERCENTILE90_INTERACK_MS,SCORE,#JITTER_BUFFER_UNDERRUN,#JITTER_BUFFER_OVERFLOW,#THREADS,TID,MEM_PERCENT,CPU_PERCENT,NET_THROUGHPUT_RX_KBPS,NET_THROUGHPUT_TX_KBPS,#TESTS,WD_PERCENT,VAR_PERCENT,TCP_STATE,TCP_CA_STATE,RCA_CAUSE_1,RCA_CAUSE_2,RCA_CAUSE_3,RETRANS_PERCENT,PERCENTILE10_BURSTUL_SNT_B,PERCENTILE50_BURSTUL_SNT_B,PERCENTILE90_BURSTUL_SNT_B,PERCENTILE10_BURSTUL_RCV_B,PERCENTILE50_BURSTUL_RCV_B,PERCENTILE90_BURSTUL_RCV_B,PERCENTILE10_BURSTDL_SNT_B,PERCENTILE50_BURSTDL_SNT_B,PERCENTILE90_BURSTDL_SNT_B,PERCENTILE10_SCORE,PERCENTILE50_SCORE,PERCENTILE90_SCORE,LISTEN_BACKLOG,RTT_SYNACK_MS,SSL_DELAY_MS,TIME_TO_SERVICE_MS,SYN_SOCKETS,SOCKETS,CLOSE_SOCKETS,STATUS,STATUS_CAUSE,DA_FIELDS,MSCORE_VERSION,";

const AVERAGE_THROUGHPUT_KEY = "THROUGHPUT_KBPS";
const MAX_THROUGHPUT_KEY = "PERCENTILE90_THROUGHPUT_KBPS";
const MIN_RTT = "RTT_MIN_MS";
const SESSION_TIME_KEY = "TIME_ELAPSED_MS";
const VOLUME_KEY = "VOLUME_B";
const MOS = "SCORE";
const RCA1 = "RCA_CAUSE_1";

/**
 * Parse the result provided by mScore
 */
export default class ResultParser {

    constructor() {

    }

    /**
     * Parse the IFS from mScore
     * @param {string} result IFS returned by mScore
     * @return {MscoreResult | null}
     */
    parse(result) {
        Logger.log("Result: " + result);
        const headers = MSCORE_HEADER.split(",");
        const results = result.split(",");
        if (headers.length > results.length) {
            Logger.log("Failed to parse the mScore ILS (missing fields [" + headers.length + "," + results.length + "])");
            return null;
        } else {
            const data = new Map();
            for (let i = 0; i < headers.length; i++) {
                data.set(headers[i], results[i].trim());
            }

            // Create Object for extras data (don't use Map for < ES6)
            const map = {};
            data.forEach(function(value, key) {
                map[key] = value;
            });

            return new MscoreResult(
                data.get(MAX_THROUGHPUT_KEY).trim(),
                data.get(AVERAGE_THROUGHPUT_KEY).trim(),
                data.get(SESSION_TIME_KEY).trim(),
                data.get(VOLUME_KEY).trim(),
                data.get(MIN_RTT).trim(),
                data.get(MOS).trim(),
                data.get(RCA1).trim(),
                map);
        }
    }
}

/**
 * mScore results
 */
export class MscoreResult {

    /**
     *
     * @param {number} maxThroughput
     * @param {number} avgThroughput
     * @param {number} sessionTime
     * @param {number} volume
     * @param {number} minLatency
     * @param {number} mos
     * @param {string} rca1
     * @param {Object} extras
     */
    constructor(maxThroughput, avgThroughput, sessionTime, volume, minLatency, mos, rca1, extras = null) {
        this.maxThroughput = parseInt(maxThroughput);
        this.avgThroughput = parseInt(avgThroughput);
        this.sessionTime = parseInt(sessionTime);
        this.volume = parseInt(volume);
        this.minLatency = parseInt(minLatency);
        this.mos = mos;
        this.rootCauseAnalysis1 = rca1;
        this.extras = extras;
    }
}



// WEBPACK FOOTER //
// ./js/core/script/executors/mscore/result/ResultParser.js